import { Modal } from 'antd';
import React, { useState, useCallback } from 'react';
import styles from '../style/ContactModal.module.scss';

type PrivateProps = {
  visible: boolean;
  onHandleContactModalCancel: () => void;
};

export default function ContactModal({
  visible,
  onHandleContactModalCancel,
}: PrivateProps) {
  const [height, setHeight] = useState(null);
  const div = useCallback((node : any) => {
    if (node !== null) {
      setHeight(node.getBoundingClientRect().height);
    }
  }, []);
  return (
    <Modal
      className={`contactModal ${styles.contactModal}`}
      title={[
        <div className={styles.modalTitle} key={'contactModal-title-container'}>
          <h1>Contact</h1>
          {/* <div>
                        Our priced services include
                        <a href="#oneOfPurchase"> One-off purchase</a>,
                        <a href="#subscription"> Subscription</a> and
                        <a href="#hosting"> Hosting</a>.
                    </div> */}
        </div>,
      ]}
      visible={visible}
      onCancel={onHandleContactModalCancel}
      width={'65vw'}
      footer={[
        <div key="contactModal-footerText"></div>,
        //  <Button key="back" onClick={handleAnalyticsCancel}>Close</Button>
      ]}
    >
      <div className={styles.contactModalContent}>
        <div className={styles.contactText}>
          <h1>Do you have any questions?</h1>
          <div className={styles.contactTextContainer}>
            <div>
              <h2>Support</h2>
              <div>
                <div>
                  <p>Contact our Customer Care team at:</p>
                  <a href="https://support.dhigroup.com/support/">DHI Customer Care Portal</a>
                </div>
              </div>
            </div>
            <div>
              <h2>Email</h2>
              <div>
                <div>
                  <p>Write to us at:</p>
                  <a href="mailto:metocean-on-demand@dhigroup.com">
                    {' '}
                    metocean-on-demand@dhigroup.com
                  </a>
                </div>
              </div>
            </div>
            <div>
              <h2>Contact Form</h2>
              <div>
                <div>
                  <p>Or fill out the form and we will contact you shortly</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={div} className={styles.contactForm}>
          <div className={styles.form}>
            <iframe
              frameBorder="0"
              id="41e17561-fb00-4f71-8f17-d36ba6cd8565"
              src={
                'https://7444fa84dfef4c4885ac3fa70f96dfe5.svc.dynamics.com/t/formsandbox/VFJBo-lF0GX0AF0edESN0g-HnOCEHyuo28Qo_a-Iq_M/6962b585-67e5-eb11-bacb-000d3a4639b4?ad=' +
                encodeURIComponent(document.location.toString())
              }
              height={`${height && height - 80}px`}
              width="100%"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
